import { useState, useRef, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import { FormErrorMessage, TextBox } from 'components/forms';
import { sendNoticeEmail } from 'utils/services';
import { CAPTCHA_KEY } from 'reduxStore/apiEndPoints';
import ModalPopup from 'components/forms/AlertModal';
import { MaskTextBox } from 'components/forms';
import { validationRule } from 'utils/global';

interface Props {
	lgShow: boolean;
	setLgShow: (status: boolean) => void;
}

const AccountTrackModal = ({ lgShow, setLgShow }: Props) => {
	const [sendAccountTrackerData, setSendAccountTrackerData] = useState({
		loading: false,
		error: false,
		success: false,
	});

	const [options, setOptions] = useState<any>({
		callback: 'not fired',
		value: null,
		load: false,
		expired: 'false',
	});

	let _reCaptchaRef = useRef<any>();
	const intl = useIntl();
	const { register, handleSubmit, watch, errors, setValue, control, setError, clearErrors } = useForm({
		mode: 'all',
	});

	const handleChange = (value) => {
		setOptions({ ...options, value: value });
		clearErrors('recaptcha');
		if (value === null) setOptions({ ...options, value: null, expired: 'true' });
	};

	const asyncScriptOnLoad = () => {
		setOptions({ ...options, callback: 'called!' });
	};

	useEffect(() => {
		if (sendAccountTrackerData.success) {
			setLgShow(false);
		}
	}, [sendAccountTrackerData.success]);

	function onSubmit(data) {
		console.log('data', data);
		// if (options.value) {
		// 	const { title, url } = selectedNotice;
		// 	const payload = {
		// 		...data,
		// 		link: data.link_type == 'IOS' ? siteSettingData?.apple_app_store : data.link_type == 'android' ? siteSettingData?.google_play_store : '',
		// 		// requested_title: title,
		// 		// requested_url: WEB_URI + url,
		// 		captcha_token: options.value,
		// 	};
		// 	sendNoticeEmail(sendAccountTrackerData, setSendAccountTrackerData, payload);
		// } else {
		// 	setError('recaptcha', {
		// 		type: 'required',
		// 		message: 'Required.',
		// 	});
		// }
	}

	return (
		<ModalPopup
			footer={true}
			size="md"
			title={<FormattedMessage id="career.account-tracker" />}
			onShow={lgShow}
			onClose={() => setLgShow(false)}
			handleSubmit={handleSubmit(onSubmit)}
			isSubmitting={sendAccountTrackerData.loading}
		>
			<MaskTextBox
				required
				containerclassname="form-group"
				label={<FormattedMessage id="career.unique-code" />}
				className="form-control"
				name="unique_code"
				control={control}
				inputMode="numeric"
				placeholder={intl.formatMessage({
					id: 'career.uniquecode-placeholder',
				})}
				maskOptions={{
					integerLimit: 10,
					allowNegative: false,
					allowDecimal: false,
					includeThousandsSeparator: false,
				}}
				rules={validationRule.textbox({ required: true, type: 'number' })}
				error={errors.unique_code}
			/>

			<TextBox
				required
				label={<FormattedMessage id="career.applicant-address" />}
				name="email_address"
				type="email"
				placeholder={intl.formatMessage({
					id: 'career.applicantAddress-placeholder',
				})}
				ref={register(validationRule.textbox({ required: true, type: 'email' }))}
				error={errors.email_address}
			/>

			{/* captcha area */}
			<div className="form-group">
				<ReCAPTCHA style={{ display: 'inline-block' }} ref={_reCaptchaRef} sitekey={CAPTCHA_KEY} onChange={handleChange} asyncScriptOnLoad={asyncScriptOnLoad} />
				<FormErrorMessage error={errors.recaptcha} />
			</div>
		</ModalPopup>
	);
};

export default AccountTrackModal;
